import { io } from "socket.io-client";

export const socket = io(process.env.REACT_APP_API_URL, {
  transports: ["websocket"],
  withCredentials: true,
});

// ⭐ LƯU USER ID SAU KHI LOGIN
export let currentUserId = null;

export const registerSocketUser = (userId) => {
  currentUserId = userId;
  socket.emit("register", userId);
};

// ⭐ TỰ ĐỘNG REGISTER LẠI MỖI KHI SOCKET CONNECT
socket.on("connect", () => {
  if (currentUserId) {
    console.log("🔄 Re-register after reconnect:", currentUserId);
    socket.emit("register", currentUserId);
  }
});
